import React from "react";
import MovieDetail from "../components/MovieDetail";

const Movie = () => {
  return <MovieDetail />;
};

export default Movie;
